const copyButton = document.getElementById("copyButton");
const toast = document.querySelector(".toast");

if (copyButton) {
	copyButton.addEventListener("click", (event) => {
		event.preventDefault();

		const siteUrl = window.location.href;

		navigator.clipboard
			.writeText(siteUrl)
			.then(() => {
				toast.classList.add("show");

				setTimeout(() => {
					toast.classList.remove("show");
				}, 2000);
			})
			.catch((err) => {
				console.error("Не удалось скопировать текст: ", err);
			});
	});
}
